'use strict';

var matchSorterUtils = require('@tanstack/match-sorter-utils');

// Define a custom fuzzy filter function that will apply ranking info to rows (using match-sorter utils)
const globalFilterFn = (row, columnId, value, addMeta) => {
    // Rank the item
    const itemRank = matchSorterUtils.rankItem(row.getValue(columnId), value);
    // Store the itemRank info
    addMeta({
        itemRank,
    });
    // Return if the item should be filtered in/out
    return itemRank.passed;
};

exports.globalFilterFn = globalFilterFn;
//# sourceMappingURL=globalFilterFn.js.map
